import config from 'SRC/config/config.json'

export const defaultDial = config.defaultDial
